export const Card = ({ data }) => {
  return (
    <div className="cod-card" style={{padding:"3rem"}}>
      <div>
        <div className="vector-image">
          <img src={data.icon} alt={data.headline} />
        </div>
        <h4>{data.headline}</h4>
       
      </div>
      <div style={{color:"#8A8F9A"}}>
          {data.cta}
   
      </div>
    </div>
  );
};
